var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLightGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2719 1.58643H18.0831L11.9414 8.606L19.1666 18.1581H13.5093L9.07834 12.3648L4.00827 18.1581H1.19534L7.76451 10.6498L0.833313 1.58643H6.63424L10.6395 6.8817L15.2719 1.58643ZM14.2852 16.4754H15.843L5.78781 3.1807H4.1162L14.2852 16.4754Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLightGrayIcon);
export default __webpack_public_path__ + "static/media/x-light-gray-icon.d5b5b43ca42b73e8ee517560561c8ec1.svg";
export { ForwardRef as ReactComponent };